/**
 * Script: main_shop_2DD-scroll-cta.js
 * Component: CTA Button Scroll Behavior
 * Description: Smooth scroll to product section and close info cards
 */

// Smooth scroll and close info card function
document.querySelectorAll('.cta-button, .cta-button-1, .cta-button-2, .cta-button-3, .cta-button-4').forEach(button => {
  button.addEventListener('click', function(event) {
    event.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    
    // Smooth scroll to the target section
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }

    // Close the information card if the button is inside one
    const infoCard = this.closest('.info-card-1, .info-card-2, .info-card-3, .info-card-4');
    if (infoCard) {
      infoCard.style.display = 'none';
      document.body.style.overflow = ''; // Re-enable scrolling on the main page
      const modalOverlay = document.getElementById('modalOverlay');
      if (modalOverlay) {
        modalOverlay.style.display = 'none'; // Hide overlay
      }
    }
  });
});
